import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { alert } from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppAlert',
  setup(__props) {

const show = computed({
	get: () => alert.show,
	set: (value: boolean) => alert.setShow(value),
})

const message = computed(() => alert.message)

return { __sfc: true,show, message }
}

})